import styled from 'styled-components'

export const Container = styled.div<{ isFetching?: boolean }>`
  box-sizing: border-box;
  padding: 50px 0 0;
  height: 100vh;
  overflow: auto;
  ${props => props.isFetching && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      margin: 0 0 20px 0;
      user-select: none;

      > div {
        &:first-child {
          cursor: pointer;
          font-size: 12px;
          padding: 10px;
          background: ${props => props.theme.palette.general.soft};

          strong {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          svg {
            width: 12px;
            height: 12px;
            transform: rotate(-180deg);
            transform-origin: 50% 50%;
            transition: 300ms ease;

            &.isClosed {
              transform: rotate(0);
            }
          }
        }

        &:last-child {
          padding: 5px 0;
          margin: 0;
          border: 1px solid ${props => props.theme.palette.general.soft};

          &.isClosed {
            display: none;
          }

          > div {
            label {
              display: flex;
              cursor: pointer;
              width: 100%;
              box-sizing: border-box;
              padding: 5px 10px;
            }

            span {
              font-size: 13px;
              margin: 0 0 0 5px;
            }
          }

          button {
            color: ${props => props.theme.palette.primary.beta};
            font-size: 12px;
            cursor: pointer;
            outline: none;
            background: none;
            border: none;
            padding: 10px;
          }
        }
      }
    }
  }
`

export const Title = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  display: flex;
  padding: 10px;
  align-items: center;
  box-sizing: border-box;
  background: ${props => props.theme.palette.general.light};
  box-shadow: -3px 3px 5px ${props => props.theme.palette.general.light};

  button {
    color: ${props => props.theme.palette.primary.alpha};
    font-size: 14px;
    cursor: pointer;
    outline: none;
    background: none;
    padding: 5px 10px;
    border: 1px solid ${props => props.theme.palette.general.greyLight};

    &[disabled] {
      color: ${props => props.theme.palette.general.grey};
    }
  }
`
